/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateUserProfileLinkDto = {
  id?: number;
  linkType: UpdateUserProfileLinkDto.linkType;
  title?: string;
  url: string;
};
export namespace UpdateUserProfileLinkDto {
  export enum linkType {
    INSTAGRAM = "INSTAGRAM",
    YOUTUBE = "YOUTUBE",
    X_TWITTER = "X_TWITTER",
    FACEBOOK = "FACEBOOK",
    TIKTOK = "TIKTOK",
    LINKEDIN = "LINKEDIN",
    WEBSITE = "WEBSITE",
    NAVER_BLOG = "NAVER_BLOG",
    NAVER_CAFE = "NAVER_CAFE",
    KYOBO = "KYOBO",
    YES24 = "YES24",
    ETC = "ETC",
  }
}
